import { useState } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  LinearProgress,
  useTheme,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { FiSearch } from "react-icons/fi";

const IPs = ({ data }) => {
  const theme = useTheme();
  const [searchText, setSearchText] = useState("");
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    {
      field: "ip",
      headerName: "IP Address",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box sx={{ fontFamily: "monospace" }}>{params.value}</Box>
      ),
    },
    {
      field: "country",
      headerName: "Country",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={`https://flagcdn.com/${params.value.toLowerCase()}.svg`}
            alt={params.value}
            style={{ width: 24, height: 16 }}
          />
          {params.value}
        </Box>
      ),
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => {
        try {
          return params.value;
        } catch (e) {
          return "Invalid Date";
        }
      },
    },
  ];

  const filteredRows = data.ips.filter((row) =>
    Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchText.toLowerCase())
    )
  );

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box
        sx={{
          mb: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          IP Access Logs
        </Typography>

        <TextField
          variant="outlined"
          placeholder="Search logs..."
          InputProps={{
            startAdornment: <FiSearch style={{ marginRight: 8 }} />,
          }}
          sx={{
            width: 300,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </Box>

      <Box
        sx={{
          height: 600,
          width: "100%",
          "& .MuiDataGrid-root": {
            border: "none",
            borderRadius: 2,
            boxShadow: theme.shadows[2],
          },
          "& .MuiDataGrid-cell": {
            borderBottom: `1px solid ${theme.palette.divider}`,
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.paper,
            borderBottom: `2px solid ${theme.palette.primary.main}`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.background.default,
          },
        }}
      >
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 25, 50]}
          pagination
          autoHeight={false}
          disableSelectionOnClick
          loading={false}
          components={{
            LoadingOverlay: LinearProgress,
          }}
          sx={{
            "& .MuiDataGrid-row:nth-of-type(even)": {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        />
      </Box>
    </Container>
  );
};
export default IPs;
